module.exports = __webpack_public_path__ + "static/media/nightmarefuel.349eb604.webp";